import { Navigate, useNavigate } from 'react-router';

import { curveLibraryApi } from '../../features/curve_import/libraryApi';
import { ReviewedCurveLibrary } from '../../features/curve_import/ReviewedCurveLibrary';
import { useAuthentication } from '../auth/authState';
import { canReviewCurveLibrary } from '../auth/curveLibraryAccess';

import '../../features/curve_import/curveImport.css';

export function CurveLibraryReviewPage() {
  const authentication = useAuthentication();
  const navigate = useNavigate();
  if (!canReviewCurveLibrary(authentication)) return <Navigate replace to="/app" />;

  const openImport = (importId: string) => {
    void navigate('/curves', { state: { importId } });
  };

  return (
    <article className="page curve-import-workspace">
      <header className="page-header">
        <h1>Curve review</h1>
        <p>Internal source review and approval.</p>
      </header>
      <ReviewedCurveLibrary
        api={curveLibraryApi}
        authenticated
        canReview
        onOpenImport={openImport}
        onFork={(result) => openImport(result.imported.id)}
      />
    </article>
  );
}
